import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MODES_PAIEMENT, MODES_PAIEMENT_COURTS } from 'src/app/core/models/parametres.model';

/** Mode de paiement en puces (un geste au lieu d'une liste déroulante) */
@Component({
  selector: 'bay-mode-paiement',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ModePaiementComponent), multi: true }],
  template: `
    <div class="bay-chips" role="radiogroup" [attr.aria-label]="label">
      <button *ngFor="let m of modesAffiches" type="button" class="bay-chip" role="radio"
        [class.active]="valeur === m" [attr.aria-checked]="valeur === m" [disabled]="disabled"
        (click)="choisir(m)">
        <span *ngIf="valeur === m" class="material-symbols-outlined" aria-hidden="true">check</span>{{ court(m) }}
      </button>
    </div>
  `
})
export class ModePaiementComponent implements ControlValueAccessor {
  @Input() label = 'Mode de paiement';
  /** Modes proposés (défaut : tous) ; un ancien mode hors liste reste affiché */
  @Input() modes: string[] = MODES_PAIEMENT;
  @Output() change = new EventEmitter<string>();

  valeur = '';
  disabled = false;
  private onChange: (v: string) => void = () => {};
  private onTouched: () => void = () => {};

  get modesAffiches(): string[] {
    return this.valeur && !this.modes.includes(this.valeur) ? [...this.modes, this.valeur] : this.modes;
  }

  court(m: string): string { return MODES_PAIEMENT_COURTS[m] || m; }

  choisir(m: string): void {
    this.valeur = m;
    this.onChange(m);
    this.onTouched();
    this.change.emit(m);
  }

  writeValue(v: string): void { this.valeur = v || ''; }
  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(d: boolean): void { this.disabled = d; }
}
